import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import "./RightsManager.css";
import {
  RIGHTS_STATE_UNASSIGNED,
  RIGHTS_STATE_NOT_REQUIRED,
  RIGHTS_STATE_EXPIRED,
  RIGHTS_STATE_EXPIRING,
  RIGHTS_STATE_VALID
} from "../../constants/rights-constants";

// Pin 2 del mockup: 4 tarjetas, sin fetch propio — leen `summary`, que ya
// pidió RightsManager.js una sola vez.
//
// Cada tarjeta filtra el panel por su estado, igual que el selector "Estado"
// de la barra de filtros: las dos terminan en el mismo handler, así que se
// comportan idéntico (el árbol colapsa y se vuelve a pedir la raíz). Volver a
// hacer clic en la tarjeta activa limpia el filtro.
const CARDS = [
  // Punto 4 de Ricardo: antes, para ver el total había que volver a hacer clic
  // en la tarjeta ya activa —el mismo clic servía para filtrar y para
  // desfiltrar—, así que "Pendientes" parecía devolver dos resultados
  // distintos. Ahora "Todos" es una tarjeta más y quitar el filtro es un acto
  // explícito, no el efecto lateral de repetir un clic.
  { state: null, cls: "all", label: "rights_manager_stat_all" },
  { state: RIGHTS_STATE_UNASSIGNED, cls: "un", label: "rights_manager_stat_unassigned" },
  // Va segunda y en gris: es la contraparte de "pendientes" —el trabajo hecho
  // frente al que falta— y por eso conviene leerlas juntas.
  { state: RIGHTS_STATE_NOT_REQUIRED, cls: "nr", label: "rights_manager_stat_not_required" },
  { state: RIGHTS_STATE_EXPIRED, cls: "ex", label: "rights_manager_stat_expired" },
  { state: RIGHTS_STATE_EXPIRING, cls: "so", label: "rights_manager_stat_expiring", hint: "rights_manager_stat_expiring_hint" },
  { state: RIGHTS_STATE_VALID, cls: "ok", label: "rights_manager_stat_valid" }
];

const RightsManagerStats = ({
  summary,
  loadingSummary,
  rightsState,
  onSelectState,
  intl
}) => {
  const total = summary.total || 0;
  const unassignedPercent = total
    ? `${((summary[RIGHTS_STATE_UNASSIGNED] || 0) / total * 100).toFixed(1)}% de las piezas`
    : "";

  const displayValue = state =>
    loadingSummary ? "—" : (state === null ? total : summary[state] || 0);

  const handleSelect = state => {
    if (!onSelectState) return;
    // Sin toggle. Repetir el clic en la tarjeta activa no hace nada; para ver
    // todo está la tarjeta "Todos", y para soltar también el filtro de tipo
    // está "Limpiar filtros" en la barra.
    onSelectState(state === null ? undefined : state);
  };

  return (
    <div
      className={`rm-stats ${loadingSummary ? "is-loading" : ""}`}
      aria-busy={loadingSummary}
    >
      {CARDS.map(card => {
        const isActive = card.state === null ? !rightsState : rightsState === card.state;
        const label = intl.formatMessage({ id: card.label });
        return (
          <div
            key={card.cls}
            className={`rm-stat ${card.cls} ${isActive ? "active" : ""}`}
            role="button"
            tabIndex={0}
            aria-pressed={isActive}
            aria-label={intl.formatMessage(
              { id: "rights_manager_stat_aria_filter" },
              { estado: label }
            )}
            onClick={() => handleSelect(card.state)}
            onKeyDown={event => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                handleSelect(card.state);
              }
            }}
          >
            <div className="num">{displayValue(card.state)}</div>
            <div className="lab">{label}</div>
            <div className="sub">
              {card.state === RIGHTS_STATE_UNASSIGNED
                ? loadingSummary
                  ? " "
                  : unassignedPercent
                : card.hint
                ? intl.formatMessage({ id: card.hint })
                : " "}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const mapStateToProps = state => ({
  summary: state.rights.summary,
  loadingSummary: state.rights.loadingSummary
});

export default injectIntl(connect(mapStateToProps)(RightsManagerStats));
